import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function LikeData() {
    this.defaultAttrs({
        likeUrl: null,
    });

    this.likeDesign = function(e, data) {
        $.ajax({
            url: this.attr.likeUrl,
            data,
            type: 'POST',
            headers: { Accept: 'application/json' },
            success: function(successData) {
                this.$node.trigger('dataDesignLikedSuccess', successData);
            }.bind(this),
            error: function() {
                this.$node.trigger('dataDesignLikedError');
            }.bind(this),
        });
    };

    this.unlikeDesign = function(e, data) {
        $.ajax({
            url: this.attr.likeUrl,
            data,
            type: 'DELETE',
            headers: { Accept: 'application/json' },
            success: function(successData) {
                this.$node.trigger('dataDesignUnlikedSuccess', successData);
                this.trigger('uiHideUnlikedDesign');
            }.bind(this),
            error: function() {
                this.$node.trigger('dataDesignUnlikedError');
            }.bind(this),
        });
    };

    this.after('initialize', function() {
        this.on(this.$node, 'uiDesignLiked', this.likeDesign);
        this.on(this.$node, 'uiDesignUnliked', this.unlikeDesign);
    });
}

export default defineComponent(LikeData);



// WEBPACK FOOTER //
// ./src/js/component_data/like.js